var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"agreement_contract"}},[_c('p',{staticClass:"user-output"},[_vm._v("\n    "+_vm._s(_vm.$t("contract.agreement.paragraphOne", { description: _vm.description }))+".\n  ")]),_vm._v(" "),_c('hr')])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/hemmelig/components/contract/AgreementOutput.vue?vue&type=template&id=2c054ed8&
// module id = null
// module chunks = 